import { CreateProdStackService } from 'types/services';
import { asyncTimeout } from 'utils/asyncTimeout';
import { RESIDENT_COUNTRY_CODE } from 'utils/constants';
import { UnexpectedError } from 'utils/errors';
import { m8API } from '../m8';
import { M8PartnerDTO, M8ProdStackDTO } from '../types';
import { normalizeM8ProdStackDTO } from '../utils/normalizeM8ProdStackDTO';
import { normalizeOrgStaffCount } from '../utils/normalizeOrgStaffCount';

export const createProdStack: CreateProdStackService = async (params) => {
  const { orgInfoFormValues, personalInfoFormValues } = params;

  const partnerCode = personalInfoFormValues.partnerCode.join('');

  let partner: null | M8PartnerDTO = null;

  if (partnerCode.length === 4) {
    partner = await m8API.user.getPartnerByCode({ partnerCode });
  }

  if (orgInfoFormValues.location === null) {
    throw new UnexpectedError();
  }

  await m8API.user.confirmDataAndGetTrial({
    firstName: personalInfoFormValues.firstName,
    lastName: personalInfoFormValues.lastName,
    middleName: personalInfoFormValues.middleName,
    organization: orgInfoFormValues.name,
    position: personalInfoFormValues.position,
    companySize: orgInfoFormValues.staffCount
      ? normalizeOrgStaffCount(orgInfoFormValues.staffCount).toCompanySize()
      : 'UNDEFINED',
    phone: personalInfoFormValues.phone,
    sex: 'MALE',
    country: orgInfoFormValues.location,
    resident: orgInfoFormValues.location === RESIDENT_COUNTRY_CODE,
    idPartner: partner ? partner.id : null,
  });

  let m8ProdStack: null | M8ProdStackDTO = null;

  while (m8ProdStack === null) {
    m8ProdStack = await m8API.user.getProdStackInfo();

    await asyncTimeout(5000);
  }

  const prodStackInfo = normalizeM8ProdStackDTO(m8ProdStack).toProdStackInfo();

  return prodStackInfo;
};
